import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, Button } from "reactstrap";
import "../assets/css/SidebarComponents/Quiz.css";
import { Row, Col } from "reactstrap";
import { QuizQuestionEnglish } from "../views/QuizEnglish.js";
import { QuizAnswersEnglish } from "../views/QuizAnswersEnglish.js";
import axiosInstance from "../apiHandles/axiosInstance.js";
import { useLanguage } from "context/LanguageProvider";
import { useDarkMode } from "context/DarkModeProvider";

const Quiz = ({
  question,
  options,
  currentQuestionId,
  onAnswerSelected,
  questionIndex,
  totalQuestions,
  onNextQuestion,
}) => {
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [answered, setAnswered] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [feedbackClass, setFeedbackClass] = useState("");
  const [isCorrect, setIsCorrect] = useState(null);  // ΝΕΟ state
  const [checking, setChecking] = useState(false);

  const { darkMode } = useDarkMode();

  const { selLanguage, toggleLanguage, isLoading } = useLanguage();

  if (isLoading) {
    return (
      <div style={{ textAlign: "center", marginTop: "100px" }}>
        <p>Φόρτωση...</p>
      </div>
    );
  }

  // ΝΕΑ συνάρτηση - Στέλνει την απάντηση στο backend
  const handleAnswerClick = async (answer) => {
    if (checking || answered) return;

    const selected = String(answer).trim();
    setSelectedAnswer(selected);
    setChecking(true);

    try {
      // Στείλε την απάντηση στο backend
      const response = await axiosInstance.post('/api/check-answer/', {
        question_id: currentQuestionId,
        answer: selected
      });

      const { correct } = response.data;
      setIsCorrect(correct);
      setAnswered(true);

      setFeedbackClass(correct ? "correct-background" : "wrong-background");
      setTimeout(() => setFeedbackClass(""), 1000);

      onAnswerSelected(correct);
    } catch (error) {
      console.error("Error checking answer:", error);
      alert("Σφάλμα κατά τον έλεγχο της απάντησης. Δοκίμασε ξανά.");
    } finally {
      setChecking(false);
    }
  };

  const handleNextClick = () => {
    if (!answered) {
      setShowModal(true);
      return;
    }
    setSelectedAnswer(null);
    setAnswered(false);
    setIsCorrect(null);
    onNextQuestion();
  };

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const s = localStorage.getItem("structureLocation");

  const colorSchemes = {
    HashTable: { primary: '#10b981', secondary: '#059669', accent: '#d1fae5' },
    Tree: { primary: '#3b82f6', secondary: '#2563eb', accent: '#dbeafe' },
    List: { primary: '#8b5cf6', secondary: '#7c3aed', accent: '#ede9fe' },
    Stack: { primary: '#f59e0b', secondary: '#d97706', accent: '#fef3c7' },
    Queue: { primary: '#ef4444', secondary: '#dc2626', accent: '#fecaca' },
    Graph: { primary: '#06b6d4', secondary: '#0891b2', accent: '#cffafe' },
    Array: { primary: '#ec4899', secondary: '#db2777', accent: '#fce7f3' },
    Set: { primary: '#84cc16', secondary: '#65a30d', accent: '#ecfccb' },
    Python: { primary: '#3776ab', secondary: '#ffd43b' }
  };

  const scheme = colorSchemes[s] || colorSchemes.Graph;

  return (
    <>
      <div
        className="quizContainer"
        style={{
          border: darkMode ? `2px solid ${scheme.primary}30` : `2px solid ${scheme.primary}80`,
          background: darkMode ? "none" : "#fff"
        }}
      >
        <Col className="quiz-inner">
          <Row style={{
            fontSize: "clamp(1rem, 2.5vw, 1.2rem)",
            fontWeight: "600",
            color: darkMode ? "white" : "black",
          }}>
            {questionIndex} / {totalQuestions}
          </Row>

          <div className="question-box">
            <p className="question-text">
              {selLanguage ? question : QuizQuestionEnglish[question.trim()] || question}
            </p>
          </div>

          <Col className="quiz-options" xl="12" lg="12" md="12" sm="12" xs="12">
            {options.map((option, index) => {
              const trimmedOption = String(option).trim();
              let buttonClass = "quiz-button";
              let customStyle = {
                background: darkMode
                  ? `linear-gradient(135deg, ${scheme.primary}25 0%, ${scheme.secondary}25 100%)`
                  : `${scheme.primary}95`,
                backdropFilter: 'blur(10px)',
                border: `2px solid ${scheme.primary}30`,
                // boxShadow: `0 10px 25px -8px ${scheme.primary}30`,
                transition: "background 0.3s, transform 0.3s ease"
              };

              // Styling βάση της απάντησης
              if (answered && selectedAnswer === trimmedOption) {
                if (isCorrect) {
                  buttonClass += " correct-shadow";
                  customStyle.background = "linear-gradient(135deg, #065f46 0%, #057b56 100%)";
                  customStyle.filter = "brightness(1.15)";
                } else {
                  buttonClass += " wrong-shadow";
                  customStyle.background = "linear-gradient(135deg, #7f1d1d 0%, #b4183a 100%)";
                  customStyle.filter = "brightness(1.15)";
                }
              }

              return (
                <button
                  key={index}
                  style={customStyle}
                  className={buttonClass}
                  onClick={() => handleAnswerClick(option)}
                  disabled={answered || checking}
                >
                  {selLanguage ? option : QuizAnswersEnglish[option]}
                </button>
              );
            })}
          </Col>

          <div style={{ textAlign: "center" }}>
            <button className="nextQuestionQuiz"
              onClick={handleNextClick}
              style={{ background: darkMode ? "#dcdcdd" : "#f4f3ef" }}
            >
              {questionIndex === totalQuestions
                ? (selLanguage ? "Ολοκλήρωση" : "Completion")
                : (selLanguage ? "Επόμενη Ερώτηση" : "Next Question")}
            </button>
          </div>
        </Col>
      </div>

      <Modal isOpen={showModal} centered contentClassName="no-shadow-modal">
        <div style={{
          background: darkMode ? "#1e293b" : "#f8fafc",
          borderRadius: '0.5rem',
          maxWidth: "90vw"
        }}>
          <ModalHeader style={{
            justifyContent: "center",
            background: darkMode ? "#1e293b" : "#f8fafc",
          }}>
            <span className="dangerLabelQuiz">
              {selLanguage ? "Προσοχή!" : "Attention!"}
            </span>
          </ModalHeader>

          <ModalBody style={{
            borderBottomLeftRadius: "0.5rem",
            borderBottomRightRadius: "0.5rem",
            background: darkMode ? "#1e293b" : "#f8fafc",
          }}>
            <p style={{
              textAlign: "center",
              color: darkMode ? "#e4e4e4ff" : "#494949ff",
              fontSize: "clamp(0.9rem, 2vw, 1rem)",
              fontFamily: "Poppins, sans-serif",
              marginBottom: "1.5rem"
            }}>
              {selLanguage
                ? "Παρακαλώ απάντησε στην ερώτηση πριν συνεχίσεις."
                : "Please answer the question before continuing."}
            </p>

            <div style={{ textAlign: "center" }}>
              <Button color="primary" onClick={toggleModal} className="ConfirmButtonQuiz">
                {selLanguage ? "Εντάξει" : "OK"}
              </Button>
            </div>
          </ModalBody>
        </div>
      </Modal>
    </>
  );
};

export default Quiz;